function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".statistics-icon{fill:url(#statistics);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "statistics",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#F66614"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7B00FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "statistics-icon",
  d: "M93.417,86.75v-26.5H75.011v-26.5H54.604v8.949H38.197V33.75H17.791v53H13.25v-83h-2v83h-7.5v2h7.5v7.5h2v-7.5h4.541h8.458  V92h2v-3.25h7.948h2h7.053V92h2v-3.25h7.354h2h7.646V92h2v-3.25h6.761h2h8.239V92h2v-3.25h8.167h2.833v-2H93.417z M19.791,86.75v-51  h16.406v6.949V86.75H19.791z M38.197,86.75V44.699h16.406V86.75H38.197z M56.604,86.75V42.699V35.75h16.407v24.5v26.5H56.604z   M75.011,86.75v-24.5h16.406v24.5H75.011z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "statistics-icon",
  points: "64.673,17.142 91.732,36.974 92.914,35.36 64.94,14.858 46.343,22.689 19.077,14.542 18.505,16.458 46.458,24.811   "
});

function SvgStatisticsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsDown);
export default __webpack_public_path__ + "static/media/statisticsDown.ca509a67.svg";
export { ForwardRef as ReactComponent };